export default "__VITE_ASSET__DjS5lTUM__"